export const TESTABLE_WORD_REGEX = /_(.+?)_/;
